(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    const header = document.querySelector(".header_cpt");
    const navbar = document.querySelector(".navbar"); // Added this selector
    const notificationBar = document.querySelector(".notification-bar");
    const notificationPageWrapper = document.querySelector(".page-wrapper-with-notification");

    // ---- Notification multiline logic ----
    function checkLines() {
      if (!notificationBar) return;

      const a = notificationBar.querySelector("a");
      if (!a) return;

      const lineHeight = parseFloat(getComputedStyle(a).lineHeight || "0");
      const textHeight = a.offsetHeight;
      const lines = lineHeight ? Math.round(textHeight / lineHeight) : 1;

      const isMultiline = lines > 1;
      notificationBar.classList.toggle("multiline", isMultiline);
      if (header) header.classList.toggle("multiline", isMultiline);
      if (notificationPageWrapper) notificationPageWrapper.classList.toggle("multiline", isMultiline);
    }

    checkLines();
    window.addEventListener("resize", checkLines);

    // ---- SCROLL LOGIC (Orbe Color Changer) ----
    function handleScroll() {
      if (!navbar) return;
      
      // If we scroll past 50px, add class. Otherwise remove it.
      if (window.scrollY > 50) {
        navbar.classList.add("scrolled");
      } else {
        navbar.classList.remove("scrolled");
      }
    }

    // Run once on load (in case we reload halfway down the page)
    handleScroll();
    // Listen for scroll events
    window.addEventListener("scroll", handleScroll);


    // ---- Mobile nav scroll lock ----
    const burger = document.querySelector("[data-burger]");
    const navCenter = document.querySelector("[data-nav-center]");

    function openNav() {
      document.body.classList.add("nav-open");
      document.documentElement.classList.add("nav-open");
    }

    function closeNav() {
      document.body.classList.remove("nav-open");
      document.documentElement.classList.remove("nav-open");
    }

    // Webflow IX2 shows/hides the drawer (inline display style), so the scroll
    // lock follows the drawer's real visibility instead of counting clicks.
    // Counting clicks drifted out of sync (e.g. after a Weglot language switch),
    // leaving the drawer open while the page behind it scrolled.
    const mobileQuery = window.matchMedia("(max-width: 767px)");

    function isNavVisible() {
      return !!navCenter && getComputedStyle(navCenter).display !== "none";
    }

    function syncNav() {
      if (mobileQuery.matches && isNavVisible()) openNav();
      else closeNav();
    }

    if (navCenter) {
      new MutationObserver(syncNav).observe(navCenter, {
        attributes: true,
        attributeFilter: ["style", "class"],
      });
      mobileQuery.addEventListener("change", syncNav);
      syncNav();
    }

    // Weglot re-renders the page on language change; re-check afterwards
    if (window.Weglot && typeof Weglot.on === "function") {
      Weglot.on("languageChanged", function () {
        setTimeout(syncNav, 50);
      });
    }

    // Esc closes menu (through the burger so IX2 stays in sync)
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && burger && isNavVisible()) burger.click();
    });
  });
  
})();